import { render } from "./B2bPageDeliveryNotes.vue?vue&type=template&id=d6788e14&scoped=true&lang=pug"
import script from "./B2bPageDeliveryNotes.vue?vue&type=script&lang=js"
export * from "./B2bPageDeliveryNotes.vue?vue&type=script&lang=js"

import "./B2bPageDeliveryNotes.vue?vue&type=style&index=0&id=d6788e14&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6788e14"]])

export default __exports__